module.exports = __webpack_public_path__ + "static/media/Punto-de-Atencion.6b93b875.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Img/productos/Punto-de-Atencion.jpg
// module id = 142
// module chunks = 0